/** Bo'sh qiymat belgisi — `ReportTable` ning `BOSH` i bilan AYNAN bir xil. */
const BOSH = "—";

/**
 * Davomat foizi — sahifadagi YAGONA formula.
 *
 * ⚠️⚠️ **`countedDays === 0` da `null`, `0` EMAS.** Bo'sh oynada «0%»
 * ko'rsatish «hech kim kelmagan» degan yolg'on ayblov bo'lardi.
 *
 * ⚠️ KPI kartasi ham, jadval katagi ham, chop etish sarlavhasi ham
 * AYNAN shu funksiyani chaqiradi. Ikki nusxa bo'lsa, biri `0%` ni,
 * ikkinchisi `—` ni ko'rsatib, bir sahifada ikki javob turardi.
 */
export function davomatFoizi(presentDays: number, countedDays: number): number | null {
	if (countedDays <= 0) {
		return null;
	}

	return presentDays / countedDays;
}

/**
 * Foizni matnga aylantiradi — bitta o'nlik, VERGUL bilan (o'zbekcha).
 *
 * ⚠️⚠️ **UCH iste'molchi bitta funksiyadan o'tadi:** KPI kartasi,
 * jadval katagi va CHOP ETISH sarlavhasi. Har biri o'z formatini
 * yozsa, qog'ozdagi «92%» bilan ekrandagi «92,4%» ajralardi va chop
 * etilgan hujjat (audit dalili — `ReportPrintView` JSDoc'i) ekrandagi
 * songa mos kelmasdi.
 */
export function foizMatni(rate: number | null): string {
	if (rate === null) {
		return BOSH;
	}

	return `${(rate * 100).toFixed(1).replace(".", ",")}%`;
}
